/**
 * Observability system public API.
 * 
 * This module exports the main entry point for the observability system.
 * Components should use domain-specific services directly:
 * - AuthObservabilityService for auth tracking
 * - AreaPageObservabilityService for area page tracking
 * - ListingObservabilityService for listing view tracking
 * - LeadObservabilityService for lead request tracking
 */

export { getObservabilityConfig } from './config';
export type { ObservabilityProvider, StandardEventAttributes } from './providers/types';
export type { ObservabilityConfig, ObservabilityProviderType } from './config';

// Domain-specific services
export { AuthObservabilityServiceImpl } from '@bedrock/auth';
export type { AuthObservabilityService } from '@bedrock/auth';
export { AreaPageObservabilityService } from './services/area-page-observability';
export { SavedSearchObservabilityService } from './services/saved-search-observability';
export { SearchPageObservabilityService } from './services/search-page-observability';
export { AgentObservabilityService } from './services/agent-observability';
export { ListingObservabilityService } from './services/listing-observability';
export { LeadObservabilityService } from './services/lead-observability';
export { LocalFocusGenerationObservabilityService } from './services/local-focus-generation-observability';

